<style src="@vueform/multiselect/themes/default.css"></style>
<template>
  <div>
    <!-- Botão moderno para abrir modal -->
    <button 
      class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-yellow-500 hover:bg-yellow-600 text-white text-sm font-medium rounded-lg transition-colors duration-150 w-full sm:w-auto justify-center"
      type="button"  
      v-on:click="toggleModal()">
      <i class="fas fa-link"></i>
      <span>Associar</span>
    </button>

    <!-- Modal backdrop com transição -->
    <transition name="modal-fade">
      <div v-if="showModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <!-- Overlay -->
        <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" @click="toggleModal()"></div>

          <!-- Centralização -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

          <!-- Modal Content -->
          <div class="inline-block align-bottom bg-white rounded-xl shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
            <!-- Header -->
            <div class="bg-gradient-to-r from-yellow-500 to-yellow-600 px-6 py-4 rounded-t-xl">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                    <i class="fas fa-link text-white text-lg"></i>
                  </div>
                  <div class="text-left">
                    <h3 class="text-xl font-bold text-white" id="modal-title">
                      Associar Usuário
                    </h3>
                    <p class="text-sm text-yellow-50 mt-0.5">
                      Vincule um usuário existente
                    </p>
                  </div>
                </div>
                <button 
                  class="text-white hover:text-yellow-100 transition-colors duration-150"
                  v-on:click="toggleModal()">
                  <i class="fas fa-times text-xl"></i>
                </button>
              </div>
            </div>

            <!-- Body -->
            <div class="px-6 py-6">
              <div class="space-y-3">
                <label class="block text-sm font-medium text-gray-700">
                  Selecione o usuário
                </label>
                <div class="relative">
                  <Multiselect
                    v-model="value"
                    :options="options"
                    placeholder="Escolha um usuário..."
                    :searchable="true"
                    :canClear="false"
                    noOptionsText="Nenhum usuário encontrado"
                    noResultsText="Nenhum resultado para essa busca"
                    class="multiselect-modern"
                  />
                </div>
                <p class="text-xs text-gray-500 mt-2">
                  <i class="fas fa-search mr-1"></i>
                  Digite para buscar o usuário pelo nome.
                </p>
              </div>
            </div>

            <!-- Footer -->
            <div class="bg-gray-50 px-6 py-4 rounded-b-xl flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
              <button 
                class="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors duration-150"
                type="button" 
                v-on:click="toggleModal()">
                <i class="fas fa-times"></i>
                <span>Cancelar</span>
              </button>
              <button 
                class="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-yellow-500 hover:bg-yellow-600 text-white text-sm font-medium rounded-lg transition-colors duration-150"
                type="button" 
                v-on:click="assignUser()">
                <i class="fas fa-check"></i>
                <span>Associar Usuário</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import Multiselect from '@vueform/multiselect'
import UserService from '@/services/userService';

export default {
  name: "ModalUserAssign",
  components: {
      Multiselect,
  },
  props: [
    'options',
    'userApproval',
    'rowId'
  ],
  mounted() {
    // UserService.getUsers().then(users => {
    //     users;
    // });
  },
  methods: {
    toggleModal: function(){
      this.showModal = !this.showModal;
    },
    assignUser: function() {
        console.log(this.userApproval.name,this.userApproval.email, this.value);
        let newUser = {
          _id: this.value,
          email: this.userApproval.email,
          approvalId: this.userApproval._id
        }

        UserService.assignUser(newUser).then(data => {
          this.$emit('update', this.rowId, data.message);
        }).catch(err => {
          this.$emit('error', err.message)
        });

        this.showModal = !this.showModal;
    }
  },
  data() {
      return {
        showModal: false,
        value: null,
      }
    }
}
</script>

<style>
@import "@vueform/multiselect/themes/default.css";

/* Transição do modal */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

/* Estilização customizada do Multiselect */
.multiselect-modern {
  --ms-font-size: 0.875rem;
  --ms-line-height: 1.5;
  --ms-bg: #ffffff;
  --ms-bg-disabled: #f3f4f6;
  --ms-border-color: #d1d5db;
  --ms-border-width: 1px;
  --ms-radius: 0.5rem;
  --ms-py: 0.625rem;
  --ms-px: 1rem;
  --ms-ring-width: 2px;
  --ms-ring-color: #eab30880;
  --ms-placeholder-color: #9ca3af;
  --ms-max-height: 15rem;
  
  --ms-option-bg-pointed: #fef3c7;
  --ms-option-bg-selected: #eab308;
  --ms-option-bg-selected-pointed: #ca8a04;
  --ms-option-color-pointed: #78350f;
  --ms-option-color-selected: #ffffff;
  --ms-option-color-selected-pointed: #ffffff;
  
  --ms-tag-bg: #eab308;
  --ms-tag-color: #ffffff;
  --ms-tag-radius: 0.375rem;
  --ms-tag-font-weight: 500;
}

.multiselect-modern:focus-within {
  border-color: #eab308;
  box-shadow: 0 0 0 2px rgba(234, 179, 8, 0.2);
}
</style>
